import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PriceBlock as PriceBlockComponent } from '../../components/PriceBlock';
import { PriceRelevance } from '../PriceRelevance';
import { CallButton } from '../CallButton';
import { SinglePhone } from '../SinglePhone';
import { trackOpenContacts, trackShowPhone } from '../../actions/analytics';
import { TThunkDispatch } from '../../types/redux';
import {
  hasContactsSelector,
  priceRelevanceSelector,
  priceForObjectSelector,
  priceForMeterSelector,
} from '../../selectors';

export const PriceBlock = (): React.JSX.Element | null => {
  const dispatch: TThunkDispatch = useDispatch();

  const priceForObject = useSelector(priceForObjectSelector);
  const priceForMeter = useSelector(priceForMeterSelector);
  const hasPriceRelevance = !!useSelector(priceRelevanceSelector);
  const hasContacts = useSelector(hasContactsSelector);

  const isPriceBlockShown = React.useMemo(() => {
    return priceForObject || priceForMeter || hasPriceRelevance || hasContacts;
  }, [priceForObject, priceForMeter, hasPriceRelevance, hasContacts]);

  const handleOpenContacts = React.useCallback(() => {
    dispatch(trackOpenContacts());
  }, [dispatch]);

  const handleShowPhone = React.useCallback(() => {
    dispatch(trackShowPhone('Open_jk_card_blockJK'));
  }, [dispatch]);

  if (!isPriceBlockShown) {
    return null;
  }

  return (
    <PriceBlockComponent
      priceRelevance={<PriceRelevance />}
      callButton={
        <CallButton
          placeType="blockStickyRightTop"
          onShowPhoneClick={handleShowPhone}
          onOpenContactsClick={handleOpenContacts}
          SinglePhoneComponent={SinglePhone}
        />
      }
      priceForObject={priceForObject}
      priceForMeter={priceForMeter}
      hasContacts={hasContacts}
    />
  );
};
